import Component from '../Component';

export default class QuickAdd extends Component {
  constructor(theme, element) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
    this.onSubmit = this.onSubmit.bind(this);
    this.currentButton = null;
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.formWrapper = /** @type {HTMLElement} */ (this.element.querySelectorAll('.quick-add-wrapper.is-singular'));
    this.addToCartForm = this.element.querySelector('#add-to-cart-form');

    if (!this.formWrapper) {
      return;
    }

    Array.prototype.forEach.call(
      this.element.querySelectorAll('.quick-add-wrapper.is-singular .shopify-product-form'),
      (el) => {
        el.addEventListener('submit', this.onSubmit);
      },
    );
  }

  async onSubmit(e) {
    // Go straight to cart page, use html form submit event.
    if (this.cartType == 'page' && this.cartAction != 'added') {
      return;
    }

    e.preventDefault();

    this.currentButton = e.currentTarget.querySelector('.quick-add-button');

    // Loading spinner.
    this.currentButton.innerHTML = `<i class="fa fa-circle-o-notch fa-spin fa-fw js"></i><span class="sr-only">${this.theme.translations.loading}</span>`;

    try {
      const formData = new FormData(e.target);
      const fetchResult = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'x-requested-with': 'XMLHttpRequest'
        },
        body: formData,
      });
      // if (!response.ok) {
      //   // FIXME: error handling
      //   return false;
      // }

      const responseJson = await fetchResult.json();

      if (!fetchResult.ok) {
        this.addToCartFailed(responseJson);
      } else {
        this.updateCart();
      }
    } catch (e) {
      console.error('Unable to add to cart: ', e);
      // FIXME error handling
    }

    return false;
  }

  updateCartFailed = (response) => {
    this.enableCartButton();
    console.error('Updating the cart failed: ', response);
  };

  updateCart = async () => {
    try {
      const fetchResult = await window.fetch('/cart.js', {
        method: 'GET',
        headers: {
          'x-requested-with': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      const responseJson = await fetchResult.json();

      if (!fetchResult.ok) {
        this.updateCartFailed(fetchResult);
      } else {
        this.updatedCart(responseJson);
      }
    } catch (error) {
      console.error(error);
    }
  };

  openCartPage = () => {
    window.location.href = this.addToCartForm
      .querySelector('#cart-link')
      .value.toString();
  };

  updatedCart = (data) => {
    this.theme.updateCartDrawer(data);
    this.enableCartButton();

    if (this.cartAction === 'cart' && this.cartType == 'page') {
      this.openCartPage();
    } else if (this.cartAction === 'added') {
      this.currentButton.innerHTML = this.theme.translations.added;

      if (this.addedTextTimeout) {
        clearTimeout(this.addedTextTimeout);
        this.addedTextTimeout = null;
      }

      this.addedTextTimeout = setTimeout(() => {
        this.currentButton.innerHTML = this.theme.translations.addToCart;
      }, 2000);
    } else {
      // this.cartAction === drawer
      this.showCart();
    }
  };

  showCart = () => {
    const cartDrawerTop = document.querySelector('.cart-drawer__top');
    let cartDrawerStatus = document.querySelector('.js-cart-drawer-status');

    // TODO: Translate the string.
    cartDrawerStatus.textContent = `Item added to your cart`;

    cartDrawerTop.appendChild(cartDrawerStatus);

    var event = new CustomEvent('cart:open');
    document.querySelector('#cartSlideoutWrapper').dispatchEvent(event);
  };

  showError = (text) => {
    let cartError = document.createElement('div');
    cartError.id = 'cart-error';
    cartError.classList.add('alert', 'alert-danger');
    cartError.textContent = text;

    this.currentButton.parentNode.insertBefore(cartError, this.currentButton.nextSibling);
  };

  enableCartButton = () => {
    if (this.addedTextTimeout) {
      clearTimeout(this.addedTextTimeout);
      this.addedTextTimeout = null;
    }

    this.currentButton.classList.remove('disabled');
    this.currentButton.disabled = false;
    this.currentButton.innerHTML = this.theme.translations.addToCart;
  };

  addToCartFailed = (response) => {
    this.enableCartButton();

    let errorText = 'Unknown error';

    if (response.status == 0) {
      errorText = 'Unable to connect to server';
    } else if (response.status == 422) {
      errorText = response.description;
    } else if (response.responseJSON) {
      // Process JSON error
      if (response.responseJSON.description) {
        errorText = response.responseJSON.description;
      } else {
        errorText = response.responseJSON.message;
      }
    } else if (response.responseText) {
      // Use plain text error
      errorText = response.responseText;
    }

    this.showError(errorText);
  };
}
